import { render, staticRenderFns } from "./equipmentForm.vue?vue&type=template&id=2b72caa4&scoped=true&"
import script from "./equipmentForm.vue?vue&type=script&lang=js&"
export * from "./equipmentForm.vue?vue&type=script&lang=js&"
import style0 from "./equipmentForm.vue?vue&type=style&index=0&id=2b72caa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b72caa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b72caa4')) {
      api.createRecord('2b72caa4', component.options)
    } else {
      api.reload('2b72caa4', component.options)
    }
    module.hot.accept("./equipmentForm.vue?vue&type=template&id=2b72caa4&scoped=true&", function () {
      api.rerender('2b72caa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionEquipmentMgr/equipmentMgr/components/equipmentForm.vue"
export default component.exports